import {Dispatch, SetStateAction, useContext, useEffect} from 'react';
import { SplashScreenContextProvider, SplashScreenContext } from '../../contexts/SplashScreenContext';

export function SplashScreen(props: any) {
  const { visible = true } = props;
  const setCount = useContext(SplashScreenContext) as Dispatch<SetStateAction<number>>;
  useEffect(() => {
    if (!visible) {
      return;
    }

    setCount((prev) => {
      return prev + 1;
    });

    return () => {
      setCount((prev) => {
        return prev - 1;
      });
    };
  }, [setCount, visible]);

  return null;
}

export function SplashScreenProvider(props: any) {
  const { children } = props;

  return <SplashScreenContextProvider>{children}</SplashScreenContextProvider>;
}
